class MenuState extends Phaser.State {

	create() {
		this.bg = this.add.sprite(0, 0, "menu-bg");
		this.titletext = this.add.sprite(10, 20, "title-text");
    this.settings = this.add.sprite(20, 350, "settings-button");
    this.play = this.add.sprite(600, 350, "play-button");

		this.back = this.add.sprite(5, 10, "backText");
		this.back.scale.set(0.6);

    this.enableNavigation();
	}

  enableNavigation() {
    this.settings.inputEnabled = true;
		this.settings.input.useHandCursor = true;
    this.settings.events.onInputDown.add(this.openSettings, this);

    this.play.inputEnabled = true;
		this.play.input.useHandCursor = true;
    this.play.events.onInputDown.add(this.startGame, this);

		this.back.inputEnabled = true;
		this.back.input.useHandCursor = true;
    this.back.events.onInputDown.add(this.goToLink, this);
  }

	goToLink() {
		window.location.href = 'http://www.rumbledom.com';
	}

  openSettings() {
    this.state.start('SettingsState');
  }

  startGame() {
    this.state.start('GameState');
  }
}

export default MenuState;
